<div class="container">
  <h3 class="page-title">Dados procedimento</h3>
  <mc-exam-template-form
    [template]="examTemplate"
    [examGroups]="examGroups"
    (canceled)="goBack()"
    (saved)="save()">
  </mc-exam-template-form>
</div>